export const ReadMore = (function () {
	'use strict';

	let $readMore;

	function init() {
		$readMore = $('.read-more');
		$readMore.each(function(){
			renderReadMore(this);
		});
	}

	function renderReadMore(el) {
		let $el = $(el);
		let $full = $el.find('.read-more__full');
		let $excerpt = $el.find('.read-more__excerpt');
		let $button = $el.find('button');

		$button.on('click', function(e){
			// console.log($full, 'btn');
			e.preventDefault();
			$full.show();
			$excerpt.hide();
		});

		$full.find('button').on('click', function(e){
			// console.log($full, 'btn');
			e.preventDefault();
			$full.hide();
			$excerpt.show();
		});
	}

	return {
		init: init,
	};
})();
